import { FC } from "react";
import { IconPropsType } from ".";

export const AngleLeft: FC<IconPropsType> = (props) => {
  return (
    <svg
      width={props.size ?? 8}
      height={props.size ?? 10}
      viewBox="0 0 8 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.74688 5L7.33343 1.50188L5.79344 -6.73154e-08L0.666875 5L5.79344 10L7.33343 8.49813L3.74688 5Z"
        fill={props.color}
      />
    </svg>
  );
};
